import { useCallback, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { TRACK_PAGE_EVENT } from '@tools/ui/mutations';
import { EventType } from '@tools/ui/types/generated/graphql';
import { parseUrl } from './utils/mos-analytics';

interface UserStore {
  currentUser?: {
    _id?: string;
  };
}

export const useLoginEventTracker = (userStore?: UserStore) => {
  const params = useParams();
  const [trackPageEventMutation] = useMutation(TRACK_PAGE_EVENT);
  const trackedUserRef = useRef<string | null>(null);

  const trackLoginEvent = useCallback(() => {
    try {
      const currentUrl = window?.location?.href || '';

      const eventData = {
        eventType: EventType.UserLoginEvent,
        pageTitle: typeof document !== 'undefined' ? document.title : '',
        url: parseUrl(currentUrl, params),
        rawUrl: currentUrl
      };

      trackPageEventMutation({
        variables: {
          input: eventData
        }
      }).catch((error) => {
        console.error('Failed to track login event', { error });
      });
    } catch (error) {
      console.error('Error preparing login event', { error });
    }
  }, [params, trackPageEventMutation]);

  useEffect(() => {
    const currentUserId = userStore?.currentUser?._id;

    if (trackedUserRef.current !== currentUserId) {
      trackedUserRef.current = currentUserId || null;

      if (currentUserId) {
        trackLoginEvent();
      }
    }
  }, [userStore?.currentUser?._id, trackLoginEvent]);

  return { trackLoginEvent };
};
